import { Inject } from '@odinjs/odin';
import { FetchAPI, FilterAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnClear, OnClick, OnMount, OnSubmit, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClearEvent, ClickEvent, MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ISO_DATE_FORMAT } from '@philips-internal/oswald-ui-model/lib/formatters/date/date-utils';
import moment from 'moment';

import { FragmentNames, PhysicianScheduleBlockAliases } from '../../../codegen';
import { ApplicationRoute } from '../../../constants/routes';
import BaseController from '../../BaseController';

import './physician-schedule-block.css';

interface ScheduleFilter {
  finalDate?: string;
  initialDate?: string;
}

@Controller({ component: PhysicianScheduleBlockAliases.PHYSICION_SCHEDULE_BLOCK_LAYOUT, fragment: FragmentNames.PHYSICIAN_SCHEDULE_BLOCK })
class PhysicianScheduleBlockController extends BaseController {

  @Inject(PhysicianScheduleBlockAliases.FETCH_SCHEDULE_BLOCK)
    fetchScheduleListApi!: FetchAPI;

  @OnMount({ target: PhysicianScheduleBlockAliases.PHYSISCIAN_SCHEDULE_FILTER })
  onFilterMount(event: MountEvent): void {

    this.context.set({ internalNavigation: false });
    const filter = event.target as FilterAPI;

    const initialDate = moment().utc().format(ISO_DATE_FORMAT);
    const finalDate = moment().add(180, 'days').utc().format(ISO_DATE_FORMAT);

    const initialFilter = {
      finalDate: finalDate,
      initialDate: initialDate,
    }

    const data = filter.restoreState(true) ? filter.getRecord() : initialFilter;
    filter.clear();
    filter.setData(data as Record<string, Value>);
  }

  @OnUnmount({ target: PhysicianScheduleBlockAliases.PHYSISCIAN_SCHEDULE_FILTER })
  onFilterUnmount(event: MountEvent): void {
    const filter = event.target as FilterAPI;
    const internalNavigation = this.context.get('internalNavigation') as boolean;
    internalNavigation ? filter.persistState() : filter.clearPersistedState();
  }

  @OnSubmit({ target: PhysicianScheduleBlockAliases.PHYSISCIAN_SCHEDULE_FILTER })
  submit(event: SubmitEvent): void {
    if (!Object.keys(event.record).length) {
      return;
    }

    const scheduleFilter: ScheduleFilter = event.record;

    let body = this.addValueToBodyFilter('initialDate', scheduleFilter.initialDate, {});
    body = this.addValueToBodyFilter('finalDate', scheduleFilter.finalDate, body);

    this.fetchScheduleListApi.setParameters({ ...body });
    this.fetchScheduleListApi.forceFetch();
  }

  private addValueToBodyFilter(field: string, value: string | undefined | string[], body: Record<string, Value>): Record<string, Value> {
    if (value) {
      return { ...body, [field]: value };
    }
    return body;
  }

  @OnClear({ target: PhysicianScheduleBlockAliases.PHYSISCIAN_SCHEDULE_FILTER })
  onUsersFilterClear(event: ClearEvent<unknown>): void {
    const filter = event.target as unknown as FilterAPI;
    filter.clear();
  }

  @OnClick({ target: PhysicianScheduleBlockAliases.ACTION_NEW_SCHEDULLE_BLOCK })
  onClickButton(): void {
    applicationContext.redirect(ApplicationRoute.PHYSICIAN_SCHEDULE_BLOCK);
  }

  @OnClick({ target: PhysicianScheduleBlockAliases.PHYSICIAN_SCHEDULE_CARD_BLOCK })
  onClickCard(event: ClickEvent): void {
    const { sequenceNumber } = event.value;

    this.context.set({ internalNavigation: true });
    applicationContext.redirect(ApplicationRoute.PHYSICIAN_SCHEDULE_BLOCK_DETAIL, { sequenceNumber });
  }

}

export default PhysicianScheduleBlockController;
